module.exports = __webpack_public_path__ + "static/media/light-theme-mode-icon.02bbecee.svg";